/**
 * Type guard function that checks if a value is a boolean.
 * Returns true if the value is a boolean, false otherwise.
 *
 * @param value - The value to check
 * @returns True if the value is a boolean, false otherwise
 *
 * @example
 * ```ts
 * import { BooleanQ } from "@pdfking/structs"
 *
 * BooleanQ(true) // true
 * BooleanQ(1) // false
 * ```
 */
export const BooleanQ = <T>(value: T): value is boolean & T => typeof value === "boolean"
